import { useCallback, useEffect } from 'react';
import { useAppDispatch, useAppSelector } from '@/hooks';
import { fetchMenuAsync, selectConfigMenu, selectIsStale, selectMainMenu, selectMenuError, selectMenuStatus } from '../../../../store/slices/menuSlice.ts';


export function useMenu() {
  const dispatch = useAppDispatch();
  const status = useAppSelector(selectMenuStatus);
  const error = useAppSelector(selectMenuError);
  const mainMenu = useAppSelector(selectMainMenu);
  const configMenu = useAppSelector(selectConfigMenu);
  const isStale = useAppSelector(selectIsStale);

  useEffect(() => {
    if ((status === 'idle' || isStale) && status !== 'loading') {
      void dispatch(fetchMenuAsync());
    }
  }, [dispatch, status, isStale]);

  const refresh = useCallback(() => { void dispatch(fetchMenuAsync()); }, [dispatch]);

  return { status, error, mainMenu, configMenu, refresh };
}
